import { Component } from "react";
import SubmitFeed from "./SubmitFeed";
import { GET_NETWORK_ICON, capitalizeFirstLetter } from "../../../../../../../../../../utils";
import { feedCreationBtnMsg } from "../../../../../SelectSource/Elements/NetworkMsg";

class ConnectChildAccount extends Component {
    state = {
        selectedAcc: null,
        accounts: [],
    }

    componentDidMount() {
        const { accountList } = this.props
        this.setState({ accounts: accountList })
    }

    createFeed = () => {
        const { selectedAcc } = this.state;
        const { accountList, createFeedFromPage } = this.props;
        createFeedFromPage(selectedAcc.acId, accountList[0].parent, selectedAcc.value2);
    }

    render() {
        const { loading, networkId } = this.props
        const { accounts } = this.state;
        const btnMsg = feedCreationBtnMsg(networkId);
        return (
            <div className="instaFacebookAuth px-3">
            <div className="pt-2">
                <div className="d-flex flex-wrap align-items-center mb-6">
                    <h3 className="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                        <span className="card-label font-weight-bolder text-dark">Connect Profile</span>
                        <span className="mt-1 font-weight-bold font-size-sm">Select the {capitalizeFirstLetter(GET_NETWORK_ICON(networkId))} Profile You'd Like to Connect</span>
                    </h3>
                </div>
            </div>
            <div className="noLoader" id="FeedInstagramForm">
                <div className="instaConnectthroughfacebook_radio_list md-radio-list">
                    <div className="row pb-4">
                        {accounts && accounts.length ? accounts.map((acc, index) => (
                            <div className="col-12" key={acc.id}>
                                <label
                                    id={`user-${acc.id}`} className="user_row__ w-100 border-bottom p-3 m-0">
                                    <div className="d-flex flex-wrap align-items-center w-100">
                                        <span className={`symbol symbol-lg-45 symbol-30 random_color-${index + 1} symbol-circle me-4`}>
                                            <span className="symbol-label font-size-h4 font-weight-bold">{acc.value2[0].toUpperCase()}</span>
                                        </span>
                                        <div className="d-flex flex-column flex-grow-1 pe-3">
                                            <h5 className="text-dark-75 font-weight-bolder font-size-lg m-0">{acc.value2}</h5>
                                        </div>
                                        <div className="d-flex align-items-center py-lg-0 py-2">
                                            <span className="option-control">
                                                <span className="radio radio-outline radio-primary">
                                                    <input id={`user${acc.id}`} onChange={() => this.setState({ selectedAcc: acc })} className="md-radiobtn" type="radio" name="pageSelect" />
                                                    <span></span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        )) : null}
                    </div>
                </div>
                <div className="click-next d-flex align-items-center py-3 px-4 rounded">
                    <p className="me-3 mb-0">{btnMsg}</p>
                    <SubmitFeed loading={loading} onSubmit={this.createFeed} onBack={this.props.backAction} />
                </div>
            </div>
        </div>
        )
    }
}

export default ConnectChildAccount;